import { AutofillValue, GetApiUserError, UserType } from '@sit/client-shared';
import { UseQueryOptions } from '@tanstack/react-query';
import { useGetUser } from '@web/api/users/use-get-user';
import { useMemo } from 'react';

export function useCompanies(options?: Omit<UseQueryOptions<UserType, GetApiUserError, UserType>, 'queryKey' | 'queryFn' | 'initialData'>) {
  const { data: user } = useGetUser(options);
  return user?.companies;
}

export function useUserAutofillDefaults() {
  const { data: user } = useGetUser();
  const autofillDefaults = useMemo(() => {
    return (user?.autofillValues ?? []).reduce<Record<string, string | undefined>>(
      (acc, { dimensionObjectName, valueId }: AutofillValue) => {
        if (dimensionObjectName) {
          acc[dimensionObjectName] = valueId;
        }
        return acc;
      },
      {},
    );
  }, [user?.autofillValues]);
  return autofillDefaults;
}
